import React from 'react'
import {useStyles} from "./AssociationInfo.css";
import {useIntl} from "react-intl";
import TagContainer from "../../../../../commons/utils/disciplines/TagContainer";
import ExperienceIndication from "../../../../../commons/utils/experience/ExperienceIndication";

const AssociationInfoCard = ({associationInfo}) => {
    const classes = useStyles()

    // Internationalization for simple strings
    const intl = useIntl();

    if (!associationInfo) {
        return ''
    }

    return (
        Object.keys(associationInfo).map((association) => {
                const disciplines = associationInfo[association].disciplines

                if (disciplines && disciplines.length > 0) {
                    return (
                        <div key={association} className={classes.disciplinesRow}>
                            <TagContainer maxTags={3}
                                          tags={associationInfo[association].disciplines.map((discipline) =>
                                              intl.formatMessage({id: `app.ids.discipline.${discipline}`}))}/>
                            <ExperienceIndication experience={associationInfo[association].experience}/>
                        </div>
                    )
                }
                return ''
            }
        )
    )
}

export default AssociationInfoCard
